import React, {useState, useEffect} from 'react';

import CountdownTimer from "../components/CountdownTimer";

import './PublicRegister.css';
import '../components/modals/PublicRegisterModalContent';
import '../components/modals/Modal.css';
import PublicRegisterModalContent from '../components/modals/PublicRegisterModalContent';

const PublicRegister = () => {

  const REACT_APP_TOURNAMENT_START_IN_MS = 1689138000000;    // FIXME

  const [registerModal, setRegisterModal] = useState(false);

  const toggleModal = () => {
    setRegisterModal(!registerModal);
  };

  if(registerModal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  return (
    <>

      {registerModal && (
        <PublicRegisterModalContent toggleModal={toggleModal} />
      )}

      <div className="pageContainer">

        <div className="tournamentContainer">

          <div className="tournamentContactContainer">
            <div className="tournamentColElement">
              <h2>Tournament Info</h2>
              <p>Billfish Pachanga</p>
              <p>July 12-15, 2023</p>
              <a target="_blank" href="https://billfishpachanga.com/">www.billfishpachanga.com</a>
            </div>
          </div>

          <div className="tournamentLogoContainer">
            <div className="tournamentColElement">
              <img src="/billfish_pachanga_logo.png" alt="error-loading-logo"></img>
            </div>
            <div className="loginContainer">
              <button className="btn" onClick={toggleModal} disabled={true}>Register</button>
            </div>
            <br/>
            <div className="tournamentColElement">
              <CountdownTimer targetDate={REACT_APP_TOURNAMENT_START_IN_MS}></CountdownTimer>
            </div>
            <div>
              <h2>Pricing</h2>
              <p><strong>Early Registration (before June 15th): </strong> $2500 per boat</p>
              <p><strong>Normal Registration (starting June 15th): </strong> $3000 per boat</p>
              <p><em>Includes 6 wristbands, extras are $175 (up to 12 extra per boat)</em></p>
              <p><em>Kids 12 and under are free</em></p>
            </div>
            <br/>
            <br/>
            <br/>
          </div>

          <div className="tournamentContactContainer">
            <div className="tournamentColElement">
              <h2>Contact Info</h2>
              <p>Cody Craig</p>
              <p>(903) 235-5195</p>
              <a target="_blank" href="mailto: arrowheadecology@gmail.com">arrowheadecology@gmail.com</a>
            </div>
          </div>

        </div> 

      </div>

    </>
  );
}

export default PublicRegister;

